<app-section-shell
  sectionId="workflow-demos"
  sectionClass="demos-section"
  sectionTitle="Workflow Tours"
  [displayResults]="displayResults"
  [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSize"
  [currentPage]="currentPage"
  [totalPages]="totalPages"
  [canGoPrev]="canGoPrev"
  [canGoNext]="canGoNext"
  (pageSizeChange)="onPageSizeChange($event)"
  (prevPage)="goToPrevPage()"
  (nextPage)="goToNextPage()">
  @for (demo of visibleDemos; track demo) {
    <div
      class="demo-card"
      [attr.data-url]="demo.videoUrl">
      <div class="card-main">
        <div class="video-thumbnail workflow">
          <img
            [src]="getThumbnail(demo)"
            [alt]="demo.name"
            class="thumbnail-img"
            crossorigin="anonymous"
            [attr.data-thumbnail-url]="getThumbnail(demo)"
          />
          <div class="play-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 5v14l11-7z"/>
            </svg>
          </div>
        </div>

        <div class="card-copy">
          <h4>{{ demo.name }}</h4>
          <p>{{ demo.description }}</p>
        </div>

        <div class="card-actions">
          <button class="favorite-btn-inline" [class.bookmarked]="bookmarkedIds.includes(demo.id)" (click)="bookmarkToggle.emit(demo.id); $event.stopPropagation()" aria-label="Favorite">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
          </button>
          <a [href]="demo.videoUrl" target="_blank" class="card-arrow" (click)="$event.stopPropagation()" aria-label="Open item">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
              <polyline points="15 3 21 3 21 9"/>
              <line x1="10" y1="14" x2="21" y2="3"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  }
</app-section-shell>
